import { IncentiveType, ScheduleFrequency, ScheduleType } from 'types/entities'
import { Locale } from 'types/locale'

export const DATE_FORMAT = 'yyyy-MM-dd'
export const TIME_FORMAT = 'HH:mm'

export const CREDIT_TYPES: IncentiveType[] = [
  'creditOneTime',
  'creditRecurring',
]

type ScheduleTypeOption = { value: ScheduleType; label: string }
export const SCHEDULE_TYPE_OPTIONS: ScheduleTypeOption[] = [
  { value: 'none', label: 'pmportal.incentives.doesNoRepeat' },
  { value: 'daily', label: 'pmportal.incentives.daily' },
  { value: 'weekly', label: 'pmportal.incentives.weekly' },
  { value: 'monthly', label: 'pmportal.incentives.monthly' },
  { value: 'yearly', label: 'pmportal.incentives.yearly' },
  { value: 'custom', label: 'pmportal.incentives.custom' },
]
export const RECURRING_SCHEDULE_TYPE_OPTIONS: ScheduleTypeOption[] = [
  { value: 'daily', label: 'pmportal.incentives.daily' },
  { value: 'weekly', label: 'pmportal.incentives.weekly' },
  { value: 'monthly', label: 'pmportal.incentives.monthly' },
  { value: 'yearly', label: 'pmportal.incentives.yearly' },
  { value: 'custom', label: 'pmportal.incentives.custom' },
]

export const WEEK_RANGE_OPTIONS = [1, 2, 3, 4, 5, 6, 7]

type ScheduleFrequencyOption = { value: ScheduleFrequency; label: string }
export const SCHEDULE_FREQUENCY_OPTIONS: ScheduleFrequencyOption[] = [
  { value: 'daily', label: 'pmportal.incentives.customDaysLabel' },
  { value: 'weekly', label: 'pmportal.incentives.customWeeksLabel' },
  { value: 'monthly', label: 'pmportal.incentives.customMonthsLabel' },
  { value: 'yearly', label: 'pmportal.incentives.customYearsLabel' },
]

export const getDateParts = (locale: Locale, date: Date) => {
  return {
    monthDay: date.getDate(),
    weekDay: date.getDay(),
    weekDayName: new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(
      date
    ),
    weekDayOrdinal: Math.ceil(date.getDate() / 7),
  }
}
